import React, { Component, useState, useEffect } from 'react'

import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'
import { makeStyles } from '@material-ui/core/styles'

import CourseTable from './CourseTable'
import Autocomplete from '@material-ui/lab/Autocomplete'
import Checkbox from '@material-ui/core/Checkbox'
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'
import CheckBoxIcon from '@material-ui/icons/CheckBox'

import { connect } from 'react-redux'
import {
  loadProgrammesData,
  loadTermsData,
  loadCoursesData,
  clearCoursesData,
  loadProgrammesDataByID,
  selectedTermUpdate,
  selectedSubAccountUpdate,
  selectedProgrammeUpdate
} from '../../actions'

import CircularProgress from '@material-ui/core/CircularProgress'

const icon = <CheckBoxOutlineBlankIcon fontSize='small' />
const checkedIcon = <CheckBoxIcon fontSize='small' />
const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 200
  }
}))

class StepOne extends Component {
  constructor(props) {
    super(props)
    this.state = { isProgrammeSelected: [], parentClicked: false }
  }

  selectedProgrammeValue = []

  componentDidMount() {
    // const classes = useStyles();

    if (this.props.data.setupProgress == 0) {
      this.props.loadProgrammesData()
      this.props.loadTermsData()
    }
  }

  render() {
    const { data, selectedSubAccountData } = this.props

    let programmes = []
    let finalSelectedSubAccounts = selectedSubAccountData //data.selectedSubAccount.data;
    const actualStep = 1
    let setupProgress = data.setupProgress

    // below are sub-account ids
    // using this we can directly load course, instead of getting nested-sub-accounts
    let timeHack = [86, 163, 83, 120, 138, 167, 2, 73, 269, 66]

    // Similar to componentDidMount and componentDidUpdate:
    // useEffect(() => {
    //   // Update the document title using the browser API

    // });

    let inputValueProgramme = data.summery.data.filter(
      (data) => data.value == 'prog'
    )
    let inputValueProgrammeSet = inputValueProgramme

    if (typeof data.programmes !== 'undefined') {
      programmes = data.programmes.data
    }

    // let terms = data.programmesByID.data;

    let terms = []

    // only these items will be filtered in the terms
    const termApplyFilters = [
      'MBA',
      'PHD',
      'TIEMBA',
      'GEMBA',
      'MIM',
      'MFIN',
      'MCC',
      'BFC',
      'Executive Master in Change',
      'Executive Master in Finance'
    ]

    const termMappings = {
      MBA: 'MBA',
      PHD: 'PHD',
      TIEMBA: 'EMBA',
      GEMBA: 'EMBA',
      MIM: 'MIM',
      MFIN: 'MFIN',
      BFC: 'BFC',
      MCC: 'MCCC',
      'Executive Master in Change': 'MCCC',
      'Executive Master in Finance': 'MFIN'
    }
    terms = data.terms.data

    if (typeof data.terms !== 'undefined') {
      if (inputValueProgramme.length === 1) {
        let filterKey = termMappings[inputValueProgramme[0].name]

        if (termApplyFilters.includes(inputValueProgramme[0].name)) {
          terms = data.terms.data.filter((item) =>
            item.name.startsWith(filterKey)
          )
        }
      }
    }

    const setProgrammeClick = (event) => {
      // this.props.clearCoursesData([]);
      this.props.selectedSubAccountUpdate([])
      // this.props.selectedTermUpdate([]);
      // finalSelectedSubAccounts = []

      for (var i = 0; i < this.props.data.summery.data.length; i++) {
        if (this.props.data.summery.data[i].value === 'prog') {
          this.props.data.summery.data.splice(i, 1)
          this.props.selectedProgrammeUpdate([])
        }
      }

      if (event !== null) {
        this.props.data.summery.data.push({
          id: event.id,
          name: event.name,
          title: 'Programme',
          value: 'prog'
        })

        this.props.selectedProgrammeUpdate([
          { id: event.id, name: event.name, title: 'Programme', value: 'prog' }
        ])

        if (timeHack.includes(event.id)) {
          let arrayhack = []
          arrayhack.push(event)
          this.props.selectedSubAccountUpdate(arrayhack)
          this.props.loadCoursesData({ programme: event.id })
        }

        this.props.loadProgrammesDataByID(event.id)
      }

      this.selectedProgrammeValue = event

      this.setState({
        isProgrammeSelected: data.summery.data.filter(
          (data) => data.value == 'prog'
        )
      })

      if (event === null) {
        this.props.clearCoursesData([])
        this.props.selectedSubAccountUpdate([])
        this.setState({ isProgrammeSelected: [] })
        this.selectedProgrammeValue = []
        finalSelectedSubAccounts = []
        // inputValueProgramme = []
        // inputValueProgrammeSet = [];
      }
    }

    const onOpenTerm = (event) => {
      if (this.selectedProgrammeValue.length == 0) {
        return false
      }
    }

    const onInputChangeProgramme = (value, reason) => {
      this.props.clearCoursesData([])
      this.props.selectedSubAccountUpdate([])
      this.setState({ isProgrammeSelected: [] })
      this.selectedProgrammeValue = []
      finalSelectedSubAccounts = []
    }

    const setSubAccountClick = (event) => {
      let subAccountIds = data.selectedSubAccount.data.map((term) => term.id)

      this.props.selectedTermUpdate([])

      if (event !== null) {
        if (event.length == 0) {
          this.props.clearCoursesData([])
        }

        for (let i = 0; i < event.length; i++) {
          let subAccount = event[i]

          let prog = data.summery.data.filter((data) => data.value == 'prog')

          if (subAccountIds.indexOf(subAccount['id']) == -1) {
            // this.props.loadCoursesData({ programme: prog[0].id, term: term['id'] })
            this.props.loadCoursesData({ programme: subAccount['id'] })
          }
        }
      }
      // }

      if (event.length == 0) {
        this.props.clearCoursesData([])
      }

      this.props.selectedSubAccountUpdate(event)
    }

    const setTermClick = (event) => {
      let termIds = data.selectedTerms.data.map((term) => term.id)

      if (event !== null) {
        if (event.length == 0) {
          //this.props.clearCoursesData([]);
        }

        for (let i = 0; i < event.length; i++) {
          let term = event[i]

          let prog = data.summery.data.filter((data) => data.value == 'prog')

          if (termIds.indexOf(term['id']) == -1) {
            //this.props.loadCoursesData({ programme: prog[0].id, term: term['id'] })
          }
        }
      }
      // }

      this.props.selectedTermUpdate(event)
    }

    if (setupProgress == 1) {
      inputValueProgrammeSet = inputValueProgramme[0]
      // finalSelectedSubAccounts = scounts[0]
    }

    let parentInputValue = inputValueProgramme

    const optionsProgrammes = programmes.map((option) => {
      const firstLetter = option.name[0].toUpperCase()
      return {
        firstLetter: /[0-9]/.test(firstLetter) ? '0-9' : firstLetter,
        ...option
      }
    })

    let programsByIdParentNames = []

    let subAccounts = data.programmesByID.data

    const subAccountsParentCount = subAccounts.filter(
      (sub) => sub.parent_name == 'MAIN'
    )

    // const subAccounts = [];

    if (subAccountsParentCount.length != subAccounts.length) {
      subAccounts = subAccounts.filter((option) => option.parent_name != 'MAIN')
    }

    let subAccountIdsForDisableItem = finalSelectedSubAccounts.map(
      (term) => term.id
    )

    let subAccountInputPlaceHolder = 'Select Sub Account(Programme)'

    if (subAccounts.length == 0) {
      subAccountInputPlaceHolder = 'Disabled, No Sub Accounts'
    }

    let termIdsForDisableItem = data.selectedTerms.data.map((term) => term.id)

    return (
      <React.Fragment>
        <Grid container spacing={3}>
          <Grid item={true} xs={12} sm={4}>
            <Autocomplete
              id='combo-box-1'
              options={optionsProgrammes.sort(
                (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
              )}
              // groupBy={(option) => option.firstLetter}
              value={parentInputValue.name}
              getOptionLabel={(option) => option.name}
              style={{ width: 300 }}
              onChange={(event, newValue) => {
                setProgrammeClick(newValue)
              }}
              defaultValue={inputValueProgrammeSet}
              renderInput={(params) => (
                <TextField {...params} label='Programmes' variant='outlined' />
              )}
            />
          </Grid>
          <Grid item={true} xs={12} sm={4}>
            <Autocomplete
              multiple
              key={[...inputValueProgramme].length ? false : true}
              disabled={
                [...inputValueProgramme].length && subAccounts.length
                  ? false
                  : true
              }
              disableCloseOnSelect
              id='combo-box-2'
              options={subAccounts}
              value={finalSelectedSubAccounts.map((term) => term)}
              // loading={data.terms.loading}
              // groupBy={(option) => option.parent_name}
              getOptionLabel={(option) =>
                typeof option.parent_name == 'undefined'
                  ? option.name
                  : option.parent_name + ' - ' + option.name
              }
              defaultValue={finalSelectedSubAccounts.map((term) => term)}
              getOptionDisabled={(option) => {
                return data.courses.loading === true
                  ? true
                  : subAccountIdsForDisableItem.indexOf(option.id) == -1 &&
                      subAccountIdsForDisableItem.length ==
                        process.env.REACT_APP_MAX_TERMS_SELECT
              }}
              renderOption={(option, { selected }) => (
                <React.Fragment>
                  <Checkbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    style={{ marginRight: 8 }}
                    checked={selected}
                    key={option.id + option.name}
                  />
                  {typeof option.parent_name == 'undefined'
                    ? ''
                    : option.parent_name + ' - '}{' '}
                  {option.name}
                </React.Fragment>
              )}
              onChange={(event, newValue) => {
                setSubAccountClick(newValue)
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={
                    [...inputValueProgramme].length
                      ? subAccountInputPlaceHolder
                      : 'Please select Programme'
                  }
                  variant='outlined'
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {data.programmesByID.loading &&
                        [...inputValueProgramme].length ? (
                          <CircularProgress color='inherit' size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    )
                  }}
                />
              )}

              // renderInput={params => <TextField {...params} label={[...inputValueProgramme].length ? "Select Terms -  (Max 5)" : "Disabled, Please select Programme"} variant="outlined" />}
            />
          </Grid>

          <Grid item={true} xs={12} sm={4}>
            <Autocomplete
              multiple
              key={
                finalSelectedSubAccounts.length && subAccounts.length
                  ? false
                  : true
              }
              disabled={
                finalSelectedSubAccounts.length && subAccounts.length
                  ? false
                  : true
              }
              disableCloseOnSelect
              id='combo-box-3'
              options={terms}
              value={data.selectedTerms.data.map((term) => term)}
              // loading={data.terms.loading}
              groupBy={(option) => option.firstLetter}
              getOptionLabel={(option) => option.name}
              defaultValue={data.selectedTerms.data.map((term) => term)}
              getOptionDisabled={(option) => {
                return (
                  termIdsForDisableItem.indexOf(option.id) == -1 &&
                  termIdsForDisableItem.length ==
                    process.env.REACT_APP_MAX_TERMS_SELECT
                )
              }}
              renderOption={(option, { selected }) => (
                <React.Fragment>
                  <Checkbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    style={{ marginRight: 8 }}
                    checked={selected}
                    key={option.id}
                  />
                  {option.name}
                </React.Fragment>
              )}
              onChange={(event, newValue) => {
                setTermClick(newValue)
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={
                    finalSelectedSubAccounts.length && subAccounts.length
                      ? 'Select Terms'
                      : 'Disabled, Select Programme'
                  }
                  variant='outlined'
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {data.terms.loading ? (
                          <CircularProgress color='inherit' size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    )
                  }}
                />
              )}
            />
          </Grid>

          {/* <Grid item={true} xs={12} sm={4}>

          <Autocomplete
              multiple
              key={finalSelectedSubAccounts.length && subAccounts.length ? false : true}
              disabled={finalSelectedSubAccounts.length && subAccounts.length ? false : true}
              disableCloseOnSelect
              id="combo-box-3"
              options={terms}
              value={data.selectedTerms.data.map(term => term)}
              // loading={data.terms.loading}
              groupBy={(option) => option.firstLetter}
              getOptionLabel={option => option.name}
              defaultValue={data.selectedTerms.data.map(term => term)}
              getOptionDisabled={(option) => { return termIdsForDisableItem.indexOf(option.id) == -1 && termIdsForDisableItem.length == process.env.REACT_APP_MAX_TERMS_SELECT }}
              renderOption={(option, { selected }) => (
                <React.Fragment >
                  <Checkbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    style={{ marginRight: 8 }}
                    checked={selected}
                    key={option.id}


                  />
                  {option.name}
                </React.Fragment>
              )}
              onChange={(event, newValue) => {
                setTermClick(newValue);
              }}

              renderInput={(params) => (
                <TextField
                  {...params}
                  label={finalSelectedSubAccounts.length && subAccounts.length ? "Select Terms" : "Disabled, Select Programme"}
                  variant="outlined"
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {data.terms.loading ? <CircularProgress color="inherit" size={20} /> : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                />
              )}

            />

          </Grid> */}

          <Grid item={true} sm={12}>
            <CourseTable></CourseTable>
          </Grid>
        </Grid>
      </React.Fragment>
    )
  }
}

function mapStateToProps(state) {
  return {
    data: state.CourseLevelAdmin,
    selectedSubAccountData: state.CourseLevelAdmin.selectedSubAccount.data
  }
}

export default connect(mapStateToProps, {
  loadProgrammesData,
  loadTermsData,
  loadCoursesData,
  loadProgrammesDataByID,
  clearCoursesData,
  selectedTermUpdate,
  selectedSubAccountUpdate,
  selectedProgrammeUpdate
})(StepOne)
